// extracted by mini-css-extract-plugin
export default {"typingContainer":"TypingEffect3_typingContainer__YWB+q","typingText":"TypingEffect3_typingText__n7mUr","cursor":"TypingEffect3_cursor__EaTRM","blink":"TypingEffect3_blink__yftrh"};